import debounce from 'debounce';
import qs from 'qs';

import { getPrivateChatSelector } from '@selectors/private-chat-selector';
import axios from '@utils/axios';

const prefix = '@PRIVATE_CHAT';

export const SET_DATA = `${prefix}/SET_DATA`;
export const SET_IS_GET_PRIVATE_CHAT_REQUEST_PROCESSING = `${prefix}/SET_IS_GET_PRIVATE_CHAT_REQUEST_PROCESSING`;
export const SET_GET_PRIVATE_CHAT_REQUEST_ERROR = `${prefix}/SET_GET_PRIVATE_CHAT_REQUEST_ERROR`;
export const READ_MESSAGES = `${prefix}/READ_MESSAGES`;
export const SEND_MESSAGE = `${prefix}/SEND_MESSAGE`;
export const SET_IS_SEND_MESSAGE_REQUEST_PROCESSING = `${prefix}/SET_IS_SEND_MESSAGE_REQUEST_PROCESSING`;
export const SET_SEND_MESSAGE_REQUEST_ERROR = `${prefix}/SET_SEND_MESSAGE_REQUEST_ERROR`;
export const ADD_NEW_UNREAD_MESSAGE = `${prefix}/ADD_NEW_UNREAD_MESSAGE`;
export const ADD_NEW_READ_MESSAGE = `${prefix}/ADD_NEW_READ_MESSAGE`;
export const SET_MESSAGES_READ = `${prefix}/SET_MESSAGES_READ`;
export const SET_SEARCH = `${prefix}/SET_SEARCH`;
export const RESET = `${prefix}/RESET`;

const setIsGetPrivateChatRequestProcessingAction = isGetPrivateChatRequestProcessing => ({
    type: SET_IS_GET_PRIVATE_CHAT_REQUEST_PROCESSING,
    payload: isGetPrivateChatRequestProcessing,
});

const setGetPrivateChatRequestErrorAction = error => ({
    type: SET_GET_PRIVATE_CHAT_REQUEST_ERROR,
    payload: error,
});

const setDataAction = data => ({ type: SET_DATA, payload: data });

export const getPrivateChatAction = (caseId, chatId) => async (dispatch, getState) => {
    const state = getState();
    const { search, currentPage, readMessages, getPrivateChatRequest, lastPage } = getPrivateChatSelector(state);
    const { isProcessing } = getPrivateChatRequest;

    if (currentPage >= lastPage || isProcessing) {
        return;
    }

    dispatch(setIsGetPrivateChatRequestProcessingAction(true));
    try {
        const queryParams = { search, page: readMessages.length ? currentPage + 1 : currentPage };

        const { data } = await axios.get(`/api/legal_cases/${caseId}/private_chats/${chatId}?${qs.stringify(queryParams)}`);

        data.caseId = caseId;
        data.chatId = chatId;

        dispatch(setDataAction(data));
    } catch (error) {
        dispatch(setGetPrivateChatRequestErrorAction(error));
    }

    dispatch(setIsGetPrivateChatRequestProcessingAction(false));
};

/* COMMON FROM GENERAL CHAT */
let messages = [];

export const clearReadMessagesQueue = () => (messages = []);

const readMessages = debounce(async (dispatch, getState) => {
    if (!messages.length) {
        return;
    }

    const { caseId, chatId } = getPrivateChatSelector(getState());

    try {
        await axios.post(`/api/legal_cases/${caseId}/${chatId}/messages/read`, { messages });

        dispatch({ type: READ_MESSAGES, payload: messages });
        messages = [];
    } catch (ex) { }
}, 300);

export const readMessagesAction = messagesIds => async (dispatch, getState) => {
    messagesIds.forEach(messageId => {
        if (messages.includes(messageId)) {
            return;
        }

        messages.push(messageId);
    });

    readMessages(dispatch, getState);
};

export const readMessageAction = messageId => readMessagesAction([messageId]);

export const setIsSendMessageRequestProcessing = isSendMessageRequestProcessing => ({
    type: SET_IS_SEND_MESSAGE_REQUEST_PROCESSING,
    payload: isSendMessageRequestProcessing,
});

export const setSendMessageRequestError = sendMessageRequestError => ({
    type: SET_SEND_MESSAGE_REQUEST_ERROR,
    payload: sendMessageRequestError,
});

export const sendMessage = (caseId, chatId, message) => async (dispatch, getState) => {
    dispatch(setIsSendMessageRequestProcessing(true));

    try {
        const { content, files } = message;
        let body = new FormData();

        body.append('content', content);
        files.forEach(file => body.append('files[]', file));

        const { data } = await axios.post(`/api/legal_cases/${caseId}/${chatId}/messages`, body);

        const state = getState();
        const { unreadMessages } = getPrivateChatSelector(state);

        if (unreadMessages.length) {
            dispatch(readMessagesAction(unreadMessages.map(({ id }) => id)));
        }

        dispatch({ type: SEND_MESSAGE, payload: data });
    } catch (ex) { }

    dispatch(setIsSendMessageRequestProcessing(false));
};

export const addNewUnreadMessage = message => ({
    type: ADD_NEW_UNREAD_MESSAGE,
    payload: message,
});

export const addNewReadMessage = message => ({
    type: ADD_NEW_READ_MESSAGE,
    payload: message,
});

export const setMessagesRead = messagesId => ({
    type: SET_MESSAGES_READ,
    payload: messagesId,
});

export const setSearch = search => ({
    type: SET_SEARCH,
    payload: search,
});

export const resetPrivateChat = () => ({ type: RESET });
